import { createFileRoute } from '@tanstack/react-router';

import { ResultTablePage } from '@results';

export const Route = createFileRoute('/_app/_admin/results_/$id/table')({
  component: ResultTablePage,
});
